/**
 * ViewModeToggle Component
 * Reusable toggle for switching between personal and school-wide views
 */

import { useAuth } from '@/hooks/useAuth';
import { useViewMode } from '@/contexts/ViewModeContext';

export const ViewModeToggle = () => {
  const { user } = useAuth();
  const { viewMode, setViewMode } = useViewMode();

  // Only show for admins
  if (!user?.isAdmin) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 bg-white rounded-xl border border-slate-200 p-1">
      <button
        onClick={() => setViewMode('personal')}
        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
          viewMode === 'personal'
            ? 'bg-emerald-600 text-white'
            : 'text-slate-600 hover:text-slate-900'
        }`}
      >
        My View
      </button>
      <button
        onClick={() => setViewMode('school')}
        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
          viewMode === 'school'
            ? 'bg-emerald-600 text-white'
            : 'text-slate-600 hover:text-slate-900'
        }`}
      >
        School View
      </button>
    </div>
  );
};
